import { useEffect } from 'react';
import { Container, Nav, Navbar } from 'react-bootstrap';
import classNames from 'classnames';
import { useLocation } from "react-router-dom";

// hooks
import { useUser } from '../../hooks/auth';

import './NavbarCSS.css';
// components
import Menu from './Menu';
import logo from '../../assets/images/logo.png';
import SalesTrackify from '../../assets/images/SalesTrackify.png';
import Menu1 from './Menu1';

type Navbar1Props = {
    isSticky?: boolean;
    navClass?: string;
    buttonClass?: string;
    fixedWidth?: boolean;
    hideSearch?: boolean;
    activeSection?: string;
    BlogPage?: boolean;
};

const Navbar1 = ({ isSticky, navClass, buttonClass, fixedWidth, hideSearch, activeSection, BlogPage }: Navbar1Props) => {
    const [loggedInUser] = useUser();
    const location = useLocation();
    const isBlogPage = location.pathname.startsWith("/blog");


    useEffect(() => {
        const navbar = document.getElementById('sticky');

        const handleScroll = () => {
            if (!navbar) return;

            if (window.scrollY >= 50) {
                navbar.classList.add('navbar-sticky');
                document.body.style.paddingTop = `${navbar.offsetHeight}px`;
            } else {
                navbar.classList.remove('navbar-sticky');
                document.body.style.paddingTop = '0px';
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);


    return (
        <header>

            {/* <Navbar
                id="sticky"
                collapseOnSelect
                expand="lg"
                className={classNames('topnav-menu', navClass)}
        
            > */}
            <Navbar
                id="sticky"
                collapseOnSelect
                expand="lg"
                className={classNames("topnav-menu", navClass)}


            >
                <Container
                    fluid
                    className="px-4 px-lg-7"
                >

                    <Navbar.Brand href="/" className="logo">
                        {/* <img src={logo} alt="logo" height="30" className="align-self-center" /> */}


                        {/* <div
                            className="bg-white rounded-pill d-flex justify-content-center align-items-center "
                            style={{
                                padding: "10px 20px",      
                                width: "fit-content",
                                height: "fit-content"
                            }}
                        > */}
                        <div className="logo-wrapper">
                            {/* <img
                                src={SalesTrackify}
                                height="40"
                                alt="logo"
                                className="d-block"
                                style={{ objectFit: "contain" }}
                            /> */}
                            <img
                                src={SalesTrackify}
                                alt="SalesTrackify"
                                className="logo-img"
                            />
                        </div>
                    </Navbar.Brand>

                    {/* <Navbar.Toggle aria-controls="responsive-navbar-nav" /> */}
                    {/* <Navbar.Toggle aria-controls="topnav-menu-content" />

                    <Navbar.Collapse id="topnav-menu-content"> */}
                    {/* <Navbar.Toggle aria-controls="main-navbar" /> */}

                    {/* <Navbar.Collapse id="main-navbar"> */}

                    {/* <Menu1
                            showDownload
                            BlogPage={isBlogPage}
                            loggedInUser={loggedInUser}
                            navClass="ms-auto align-items-lg-center"
                            buttonClass={buttonClass ? buttonClass : 'btn-primary'}
                        /> */}
                    <Menu1
                        showDownload
                        BlogPage={isBlogPage}
                        loggedInUser={loggedInUser}
                        navClass="ms-auto align-items-lg-center"
                        buttonClass={buttonClass ? buttonClass : 'btn-primary'}

                    />
                    {/* </Navbar.Collapse> */}
                </Container>
            </Navbar>

        </header >
    );
};

export default Navbar1;
